export const TEST_AND_DEMO_USER_COUNT_AI_STORAGE_KEY = 'demo-user-neuralink-button-count';

export enum ReplySourceTypeEnum {
    Neuronetwork = 'neuronetwork',
}
